import Vue from "vue";
import ApiService from '@/services/ApiService';
const { $gettext } = Vue.prototype;
export default {
  login(input) {
    return ApiService().post('/auth', input);
  },
  menu: [
    {
      icon: "cash-register",
      text: $gettext("Customer"),
      route: "customer",
      permission: "addCustomer"
    },
    {
      icon: "question-square",
      text: $gettext("FAQ"),
      route: "faq",
      permission: "addFaq"
    },
    {
      icon: "newspaper",
      text: $gettext("News"),
      route: "news",
      permission: "addNews"
    },
  ]
};
